var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewProjectWebsite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2940",
    "data-name": "Group 2940",
    transform: "translate(-524 -317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6441",
    "data-name": "Path 6441",
    d: "M0,20.129V6.71A6.71,6.71,0,0,1,6.71,0H97.29A6.71,6.71,0,0,1,104,6.71V20.129",
    transform: "translate(524 317)",
    fill: "#00feff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6442",
    "data-name": "Path 6442",
    d: "M0,127.907V48.387H104v79.52a4.35,4.35,0,0,1-4.351,4.351H4.351A4.35,4.35,0,0,1,0,127.907",
    transform: "translate(524 288.742)",
    fill: "#00feff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6443",
    "data-name": "Path 6443",
    d: "M30.843,18.839a3.357,3.357,0,1,1-2.626-2.645,3.361,3.361,0,0,1,2.626,2.645",
    transform: "translate(509.871 307.581)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6444",
    "data-name": "Path 6444",
    d: "M63.1,18.839a3.357,3.357,0,1,1-2.626-2.645A3.361,3.361,0,0,1,63.1,18.839",
    transform: "translate(491.033 307.581)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6445",
    "data-name": "Path 6445",
    d: "M95.359,18.839a3.357,3.357,0,1,1-2.626-2.645,3.361,3.361,0,0,1,2.626,2.645",
    transform: "translate(472.193 307.581)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6446",
    "data-name": "Path 6446",
    d: "M182.774,91.734v15.935l-13.419,7.968V99.7Z",
    transform: "translate(425.098 263.427)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6447",
    "data-name": "Path 6447",
    d: "M150.516,72.581l13.419,7.968-13.419,7.968L137.1,80.548Z",
    transform: "translate(443.936 274.613)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6448",
    "data-name": "Path 6448",
    d: "M137.1,91.734v15.935l13.419,7.968V99.7Z",
    transform: "translate(443.936 263.427)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6449",
    "data-name": "Path 6449",
    d: "M94.065,91.734v15.935l-13.419,7.968V99.7Z",
    transform: "translate(476.902 263.427)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6450",
    "data-name": "Path 6450",
    d: "M61.807,72.581l13.419,7.968L61.807,88.516,48.387,80.548Z",
    transform: "translate(495.742 274.613)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6451",
    "data-name": "Path 6451",
    d: "M48.387,91.734v15.935l13.419,7.968V99.7Z",
    transform: "translate(495.742 263.427)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6452",
    "data-name": "Path 6452",
    d: "M138.419,168.347v15.935L125,192.25V176.314Z",
    transform: "translate(451 218.686)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6453",
    "data-name": "Path 6453",
    d: "M106.161,149.193l13.419,7.968-13.419,7.968-13.419-7.968Z",
    transform: "translate(469.838 229.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6454",
    "data-name": "Path 6454",
    d: "M92.742,168.347v15.935l13.419,7.968V176.314Z",
    transform: "translate(469.838 218.686)",
    fill: "#9734eb"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewProjectWebsite);
export default __webpack_public_path__ + "static/media/new-project-website.e5e20fbf626fc69376baf16de5066f67.svg";
export { ForwardRef as ReactComponent };